export default __webpack_public_path__ + "media/images/logos/logo-0dabef10b9fecddcf2dde3912fd23990.svg";